import { Flex, Icon, Tooltip } from '@webkom/lego-bricks';
import cx from 'classnames';
import styles from './TextWithIcon.module.css';
import type { ReactElement, ReactNode } from 'react';

export type TextWithIconProps = {
  iconNode: ReactNode;
  className?: string;
  content: ReactNode;
  tooltipContent?: ReactElement<any>;
  iconRight?: boolean;
  size?: number;
  gap?: number | string;
};

const TextWithIcon = ({
  iconNode,
  className,
  content,
  tooltipContent,
  iconRight = false,
  size,
  gap = 'var(--spacing-sm)',
}: TextWithIconProps) => {
  const icon = (
    <Icon
      iconNode={iconNode}
      className={styles.infoIcon}
      size={size ? size : undefined}
    />
  );

  return (
    <Flex
      alignItems="center"
      gap={gap}
      className={cx(styles.overflowWrap, className)}
    >
      {iconRight && (
        <div className={styles.textContainer}>
          <span>{content}</span>
        </div>
      )}
      {tooltipContent ? (
        <Tooltip content={tooltipContent}>{icon}</Tooltip>
      ) : (
        <>{icon}</>
      )}
      <div>{iconRight ? <></> : <>{content}</>}</div>
    </Flex>
  );
};

export default TextWithIcon;
